<template>
  <div>
    <div>
      <v-layout wrap class="mt-3">
        <v-flex xs6 class="pt-2"
          ><h3>
            <i class="fab fa-facebook-square mr-2" />
            {{ $t('Connect chatbot to Facebook Ads Manager') }}
            <v-premium-lock2
              :value="!check_privilege('instagram')"
              type="premium"
            ></v-premium-lock2>
          </h3>
        </v-flex>
        <v-flex xs6>
          <div v-if="selectedBot.facebook_ad_account_id" class="success--text pt-2 pl-2">
            {{ $t('Connected') }}
            <a
              v-if="!loading"
              href="javascript:void(0);"
              @click="saveAccount('Unlink')"
              outline
              color="primary"
              >({{ $t('Unlink') }})</a
            >
            <v-progress-circular v-else indeterminate color="primary"></v-progress-circular>
          </div>
          <div v-else>
            <template>
              <v-btn
                color="#3c5a99"
                :disabled="!check_privilege('instagram')"
                :dark="check_privilege('instagram')"
                depressed
                @click="isConnect = true"
              >
                <i class="fab fa-facebook-square mr-2" />{{ $t('Connect') }}
              </v-btn>
            </template>
          </div>
        </v-flex>
      </v-layout>
      <div
        v-if="selectedBot.facebook_ad_account_id"
        class="mr-2 pa-4"
        style="display: inline-block"
      >
        <img
          class="responsive-img circle mr-2"
          alt
          style="vertical-align: middle;opacity: 0.5;"
          width="48"
          height="48"
          :src="'/static/img/bag.png'"
        />

        <span class="mt-2" style="vertical-align: -webkit-baseline-middle;"
          >{{
            selectedBot.facebook_ad_account_name
              ? selectedBot.facebook_ad_account_name
              : selectedBot.pagename
          }}
          ({{
            selectedBot.facebook_ad_account_id
              ? selectedBot.facebook_ad_account_id
              : selectedBot.pageid
          }})</span
        >
      </div>
    </div>
    <v-dialog v-if="isConnect" persistent v-model="isConnect" max-width="1000">
      <v-card>
        <div class="text-xs-right">
          <v-btn flat small fab @click="isConnect = false">
            <v-icon>
              close
            </v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <div class="intent-item " style="padding: 10px 15px 0px;">
            <form>
              <v-layout wrap>
                <v-flex xs12 sm12>
                  <div class="form-control pa-1" :class="{ 'has-error': errors.has(`Account`) }">
                    <h3 class="mb-2">{{ $t('Facebook Ad Account ID') }}</h3>
                    <input
                      :placeholder="$t('please_enter_facebook_ad_account_id')"
                      :data-vv-as="$t('Account')"
                      v-model="account"
                      v-validate="'required'"
                      :name="`Account`"
                      class="form-control mr-3"
                      type="text"
                    />
                    <span class="text-error" v-if="errors.has(`Account`)">{{
                      errors.first(`Account`)
                    }}</span>
                  </div>
                </v-flex>
                <span> {{ $t('to_connect_you_must_have_ads_account_in_ads_manager') }}</span>
              </v-layout>
              <div class="text-xs-center">
                <v-btn outline color="grey" :loading="loading" @click="isConnect = false">{{
                  $t('cancel')
                }}</v-btn>
                <v-btn depressed color="primary" :loading="loading" @click="saveAccount">{{
                  $t('Save')
                }}</v-btn>
              </div>
            </form>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      loading: false,
      isConnect: false,
      account: null
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted() {},
  methods: {
    async saveAccount(param) {
      this.loading = true
      var vm = this
      let isValid = await this.$validator.validateAll()
      if (param == 'Unlink') {
        isValid = true
        this.account = null
      }

      if (isValid) {
        var data = {
          pageid: this.selectedBot.pageid,
          body: { facebook_ad_account_id: this.account }
        }
        var response = await api.updatePageConfig(data)
        if (response.success) {
          vm.$swal
            .fire({
              title: vm.$t('Successfully'),
              text:
                param == 'Unlink'
                  ? vm.$t('Account ID has been unlinked')
                  : vm.$t('Account ID has been save'),
              type: 'success'
            })
            .then(result => {
              if (result.value) {
                vm.$store.dispatch('updateBotDetail')
                vm.isConnect = false
              }
            })
        } else {
          vm.$swal.fire({
            title: vm.$t('Unsuccessful'),
            text: vm.$t('invalid_account_id'),
            type: 'error'
          })
        }
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$size: 50px;
.instagram {
  /////// Use radial gradients to get the rounded
  /////// gradient effect in each corner

  ///// left bottom
  background: radial-gradient(circle farthest-corner at 35% 90%, #fec564, transparent 50%),
    radial-gradient(circle farthest-corner at 0 140%, #fec564, transparent 50%),
    // left top
      radial-gradient(ellipse farthest-corner at 0 -25%, #5258cf, transparent 50%),
    radial-gradient(ellipse farthest-corner at 20% -50%, #5258cf, transparent 50%),
    //  right top
      radial-gradient(ellipse farthest-corner at 100% 0, #893dc2, transparent 50%),
    radial-gradient(ellipse farthest-corner at 60% -20%, #893dc2, transparent 50%),
    // right bottom
      radial-gradient(ellipse farthest-corner at 100% 100%, #d9317a, transparent),
    /////// create a base coat to smooth
      /////// corner gradients
      linear-gradient(#6559ca, #bc318f 30%, #e33f5f 50%, #f77638 70%, #fec66d 100%);

  border-radius: 0.2em;
  font-size: $size;
  height: 1em;
  position: relative;
  width: 1em;

  &:before,
  &:after {
    color: #fff;
    content: '';
    display: block;
    position: absolute;
    border: 0.075em solid;
  }

  &:before {
    border-radius: inherit;
    height: 0.75em;
    transform: translate(0.125em, 0.125em);
    width: 0.75em;
  }

  &:after {
    border-radius: 1em;
    box-shadow: 0.2em -0.2em 0 -0.16em;
    height: 0.4em;
    transform: translate(0.3em, 0.3em);
    width: 0.4em;
  }
}

.middle {
  & > * {
    vertical-align: middle;
    line-height: normal;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/customAudience/ConnectAccount.vue